export default "__VITE_ASSET__4bc6d1bb__"